/**
 * @generated SignedSource<<7798eebc5cdd8ffaff1cf2362c796d76>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type HomePanelMoveGroupMutation$variables = {
  groupId: string;
  position: number;
};
export type HomePanelMoveGroupMutation$data = {
  readonly moveGroup: {
    readonly viewer: {
      readonly homePanelGroups: ReadonlyArray<{
        readonly id: string;
        readonly order: number;
      } | null> | null;
    };
  } | null;
};
export type HomePanelMoveGroupMutation$rawResponse = {
  readonly moveGroup: {
    readonly viewer: {
      readonly homePanelGroups: ReadonlyArray<{
        readonly id: string;
        readonly order: number;
      } | null> | null;
      readonly id: string;
    };
  } | null;
};
export type HomePanelMoveGroupMutation = {
  rawResponse: HomePanelMoveGroupMutation$rawResponse;
  response: HomePanelMoveGroupMutation$data;
  variables: HomePanelMoveGroupMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "groupId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "position"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "groupId",
    "variableName": "groupId"
  },
  {
    "kind": "Variable",
    "name": "position",
    "variableName": "position"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "HomePanelGroup",
  "kind": "LinkedField",
  "name": "homePanelGroups",
  "plural": true,
  "selections": [
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "order",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "HomePanelMoveGroupMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "MoveGroupMutation",
        "kind": "LinkedField",
        "name": "moveGroup",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Viewer",
            "kind": "LinkedField",
            "name": "viewer",
            "plural": false,
            "selections": [
              (v3/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "HomePanelMoveGroupMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "MoveGroupMutation",
        "kind": "LinkedField",
        "name": "moveGroup",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Viewer",
            "kind": "LinkedField",
            "name": "viewer",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "bf17106e04a2d598d01bde76015829bd",
    "id": null,
    "metadata": {},
    "name": "HomePanelMoveGroupMutation",
    "operationKind": "mutation",
    "text": "mutation HomePanelMoveGroupMutation(\n  $groupId: ID!\n  $position: Int!\n) {\n  moveGroup(groupId: $groupId, position: $position) {\n    viewer {\n      homePanelGroups {\n        id\n        order\n      }\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "bda84a0b21d4f81a65abaac208b62be2";

export default node;
